<div>
  <a class="file-folder" (click)="clicked(basefolder)">Course</a>
</div>
<div *ngFor="let item of basefolder?.folders">
  <app-file-folder *ngIf="item.type=='filefolders'" [item]="item" (navigateItem)="clicked($event)" [active]="folder"></app-file-folder>
</div>
